import { Component, OnInit, ViewChild,OnChanges,SimpleChanges } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { WebapiService } from '../shared/services/webapi.service';
import { Router, ActivatedRoute } from '@angular/router';
declare var bootstrap;
declare var $: any;

@Component({
  selector: 'app-playlist-view',
  templateUrl: './playlist-view.component.html',
  styleUrls: ['./playlist-view.component.scss']
})
export class PlaylistViewComponent implements OnInit,OnChanges {
  @ViewChild('videoFileContainer', { static: false }) videoFileContainer;
  skillSubmitting=false;
  legalitySubmitting=false;
  videoDetails:any;
  page=1
  user:any;
  playlist=[];
  totalvideo = 0;
  playlistid='';
  index=0;
  
  noVideos=false;

  constructor(private toastrService: ToastrService, public webApi: WebapiService, private route: ActivatedRoute, public router: Router) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.videoFileContainer) {
      this.videoFileContainer.nativeElement.load();
      //this.videoFileContainer.nativeElement.play()
    }
  }

  ngOnInit(): void {
    //console.log(this.route.snapshot.params); // outputs: {slug: "angular"}
    //console.log(this.route.snapshot.params['slug']); // outputs angular
    // or we can use get method
    //console.log(this.route.snapshot.paramMap.get("slug")); // outputs angular
    this.playlistid = this.route.snapshot.paramMap.get("slug");
    if(this.playlistid){
      this.playlistid = this.playlistid.split('-').pop()
    }
    this.getVideos();
  }

  getVideos(){
    this.noVideos = false;
    this.webApi.setLoader(true);
    let params= {
      "keyword":'',
      "playlist_id":this.playlistid,
      "page":this.page
    }
    this.webApi.getPlaylistVideos(params).subscribe((video: any) => {
      this.playlist = [...this.playlist,...video.videos]; 
      if(this.playlist.length==0){
        this.noVideos=true
      }
      this.videoDetails = this.playlist.find(() => true)

      setTimeout(()=>{
        var myVideo = document.getElementsByTagName("video")[0];
        myVideo.addEventListener('ended',this.myNewSrc,false);
      },3000);

      this.totalvideo = video.total; 
      this.webApi.setLoader(false);
    },
    error => {
      this.toastrService.error("unable to handle response");
    });
  }

  getThumbUrl(url : string){
    return  "assets/images/"+url
  }

  getVideoUrl(url : string){
    return  "assets/videos/"+url
  }

  
  openDetails(videos){
    if(videos.allowed==0){
      setTimeout(()=>{
        if(document.getElementById('videos-locked-popup-modal')){
          var myModal = new bootstrap.Modal(document.getElementById('videos-locked-popup-modal'), {
            keyboard: true
          })
          myModal.show()
          //console.log('show-new-vids modal')
        }
      },300)
      return 
    }

    for(let [index, item] of this.playlist.entries()){
      if(item.id == videos.id){
        this.index = index
      }
    }
    $('video').trigger('pause');
    this.videoDetails = videos
    if (this.videoFileContainer) {
      this.videoFileContainer.nativeElement.load();
      //this.videoFileContainer.nativeElement.play()
    }

    // setTimeout(()=>{
    //   $('video').trigger('play');
    // },1000);
    
  }
  myNewSrc() {
      var myVideo = document.getElementsByTagName("video")[0];
      if(this.index<this.playlist.length-1){
        this.index=this.index+1;
        myVideo.src = this.playlist[this.index];
        myVideo.load();
        myVideo.play();
      }
      
  }
  
}
